import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AntdModule } from '../Antd.module';
import { HeaderComponent } from './components/header/header.component';
import { LayoutComponent } from './components/layout/layout.component';
import { SidebarComponent } from './components/sidebar/sidebar.component';
import { RouterModule } from '@angular/router';
import { DateTimePipe } from './pipes/date-time.pipe';
import { MonacoEditorComponent } from './components/monaco-editor/monaco-editor.component';
import { LoadingOverlayComponent } from './components/loading-overlay/loading-overlay.component';
import { NotificationComponent } from './components/notification/notification.component';

@NgModule({
  declarations: [
    LayoutComponent,
    HeaderComponent,
    SidebarComponent,
    DateTimePipe,
    MonacoEditorComponent,
    LoadingOverlayComponent,
    NotificationComponent,
  ],
  imports: [CommonModule, AntdModule, RouterModule],
  exports: [
    LayoutComponent,
    HeaderComponent,
    SidebarComponent,
    DateTimePipe,
    MonacoEditorComponent,
    LoadingOverlayComponent,
  ],
})
export class SharedModule {}
